// extracted by mini-css-extract-plugin
export default {"History":"History_History__uOpe5","table":"History_table__onnQm","year":"History_year__9GAKG"};